
import api from "@/utils-khfw/crosRequestHandler.js";
import qs from "qs";
//用户中心接口涉及全国平台的应用分发，需调取地方平台接口
import request from "@/api/local.js";
import {MSSCY_API} from "@/config/app.config.js";
// 加密透传的方式调用用户中心接口
// const crosRequest = function (obj) {
//     sessionStorage.needConsole = 1;
//     const query = obj.params ? "?" + qs.stringify(obj.params) : "";
//     return api({
//       method: "post",
//       data: {
//         intername: obj.intername || 'addressListV7.url', // 7.0:addressListV7.url ||  6.0:aamif.url
//         requestUri: obj.url + query,
//         requestType: obj.method,
//         data: obj.data || "null",
//       },
//     });
// };
// ===================================================
// 根据persionId/usessionId 获取ticket
export async function  getTicket(uid) {
    const { code, result, message }= await request({
        url:'/account/api/account/create-ticket',
        method: "post",
        data:{
          usession_id: uid || ''   
        }
    });
    if(code=='000000'){
       return result
    }else{
       console.error(message) 
    }
}
// 获取用户基本信息
export function getSixUser(params) {
    return request({
        url:`/aamif/rest/ticketvalid/${params.ticket}`,
        method: "get",
    });
}
export function getSevenUser(params) {
    return request({
        url:`/account/api/account/verify-ticket-info?ticket=${params.ticket}`,
        method: "get",
    });
}
//根据usession_id获取用户信息
export function getUserInfoByUsessionId(params) {
    return request({
        url:'/user/api/user/get-user-info-by-usession-id',
        method: "GET",
        params,
    });
}
//获取机构 详情
export function getOrgInfo(data) {
    return request({
        url:'/user/api/org/get-org-info-custom',
        method: "POST",
        data,
    });
}
//获取企业列表
export function getOrgList(data) {
    return request({
        url:'/user/api/org/query-org',
        method: "POST",
        data,
    });
}
//新建企业
export function createOrg(data) {
    return request({
        url:'/user/api/org/create-org',
        method: "POST",
        data,
    });
}
//企业详情
export function getQYInfo(params) {
    return request({
        url:'/user/api/org/get-org-info',
        method: "get",
        params,
    });
}
//获取组织成员详细列表
export function getOrgQYList(params) {
    return request({
        url:'/user/api/user/get-org-member-list-qy',
        method: "get",
        params,
    });
}
//获取组织成员详细列表
export function getAllUserList(data) {
    return request({
        url:'/user/api/stats/user-info-list-qy',
        method: "POST",
        data,
    });
}
//获取在职组织成员详细列表
export function getOrgMemberList(params) {
    return request({
        url:'/user/api/user/get-org-member-list',
        method: "get",
        params,
    });
}
//获取组织成员简单列表
export function getOrgMemberSimpleList(params) {
    return request({
        url:'/user/api/user/get-org-member-simple-list',
        method: "get",
        params,
    });
}
//添加部门成员
export function addMember(data) {
    return request({
        url:'/user/api/org/add-member',
        method: "POST",
        data,
    });
}
//获取用户个人信息;
export function getUserInfo(params) {
    return request({
        url:'/user/api/user/get-user-info',
        method: "GET",
        params,
    });
}
//获取机构下某个用户的用户信息;
export function getMemberInfo(params) {
    return request({
        url:'/user/api/org/get-member-info',
        method: "GET",
        params,
    });
}
//设置用户状态
export function setUserStatus(data) {
    return request({
        url:'/user/api/user/set-user-status',
        method: "POST",
        data,
    });
}
//移出组织人员
export function delMember(data) {
    return request({
        url:'/user/api/org/del-member',
        method: "POST",
        data,
    });
}
//更新部门成员信息
export function updateMember(data) {
    return request({
        url:'/user/api/org/update-member',
        method: "POST",
        data,
    });
}
//重置组织成员密码
export function resetPassword(data) {
    return request({
        url:'/user/api/org/reset-member-password',
        method: "POST",
        data,
    });
}

//获取全校教师列表
export function schoolTeacherList(data) {
    return request({
        url: "/user/api/user/get-org-member-list",
        method: "get",
        params:data
    });
}
//获取所有区域
export function getChildAreaInfo(area_code) {
    return request({
        url:`/user/api/area/get-child-area-info?area_code=${area_code}`,
        method: "GET",
    });
}
//多级联动查询区域
export function getNextAreaInfo(params) {
    return request({
        url: "/user/api/area/get-child-area-info",
        method: "get",
        params
    });
}
//获取所有区域信息
export function getAllAreaInfo(params) {
    return request({
        url: "/user/api/area/get-all-area-info",
        method: "get",
        params
    });
}
//获取组织添加成员/更新成员时的必填可选字段信息
export function getMustField(params) {
    return request({
        url:'/user/api/org/get-org-member-must-field',
        method: "get",
        params
    });
}
//获取用户隐私信息密文（支持批量数据）
export function getUserPrivacyInfo(data) {
    return request({
        url:'/user/api/user/get-user-privacy-info',
        method: "post",
        data
    });
}
//区编码获取区信息
export function getAreaInfo(data) {
    return request({
        url: "/user/api/area/get-area-info",
        method: "get",
        params:data
    });
}
//获取组织管理员列表
export function getManager(data) {
    return request({
        url: "/user/api/role/get-manager",
        method: "post",
        data
    });
}
//查询用户在顶级组织是否管理员
export function getIsManager(data) {
    return request({
        url: "/user/api/role/is-manager",
        method: "post",
        data
    });
}
//切换机构
export function changeUserTopOrg(data) {
    return request({
        url: "/user/api/user/change-user-top-org",
        method: "post",
        data
    });
}
//获取机构信息列表
export function getOrgInfoList(data) {
    return request({
        url: "/user/api/stats/org-info-list",
        method: "post",
        data
    });
}
// 获取组织等级, 用于区分省,市,区教育局 省级:99  市级:1,10  区县级:2,20,4,40
export function getUserLevel(data) {
    return api({
        url:`${MSSCY_API}/msscy/user/level`,
        method: "POST",
        data,
    });
}
 // 获取机构、学校等组织隐私信息密文
export function getOrgPrivacyInfo(data) {
    return api({
        url:`${MSSCY_API}/msscy/org/privacy`,
        method: "POST",
        data
    });
}
 // 获取用户隐私信息密文
 export function getUserMcyInfo(data) {
    return api({
        url:`${MSSCY_API}/msscy/user/privacy`,
        method: "POST",
        data
    });
}
 // 获取各地方平台配置
 export function getPlatformSysconfig(data) {
    return api({
        url:`${MSSCY_API}/msscy/platform/h5sysconfig`,
        method: "POST",
        data
    });
}
